export default __webpack_public_path__ + "static/media/slider_1.c064a0b9.jpeg";